import {Injectable} from "@angular/core";
import {FormControl, FormGroup} from "@angular/forms";

@Injectable()
export class FolhaESocialUtil {

  static columns = {
    columnsFuncionarios: ['name', 'cpfFormatted', 'valueFormatted', 'paid'],
    columnsFuncionariosSubgrid: [
      {field: 'code', headerText: 'Código'},
      {field: 'description', headerText: 'Descrição'},
      {field: 'typeFormatted', headerText: 'Tipo', disableHtmlEncode: false},
      {field: 'amountFormatted', headerText: 'Quantidade'},
      {field: 'valueFormatted', headerText: 'Valor', disableHtmlEncode: false}
    ],
    columnsFGTS: ['description', 'valueFormatted', 'paid'],
    columnsFGTSSubgrid: [
      {field: 'code', headerText: 'Código'},
      {field: 'description', headerText: 'Descrição'},
      {field: 'baseCalcValueFormatted', headerText: 'Valor base de cálculo'},
      {field: 'valueFormatted', headerText: 'Valor'},
    ],
    columnsINSS: ['description', 'valueFormatted', 'paid'],
    columnsINSSSubgrid: [
      {field: 'code', headerText: 'Código'},
      {field: 'description', headerText: 'Descrição'},
      {field: 'valueFormatted', headerText: 'Valor'},
    ]
  };

  static processData(serverData, memberCpf) {
    let result = {
      inss: [],
      fgts: [],
      servers: [],
    };

    for (const key in serverData) {
      if (key == memberCpf) {
        result.inss = [...this.processDataInssIr(serverData[key].table.filter(row => row[11] === 'TB_INSS' || row[11] === 'TB_IRPF'))];
        result.fgts = [...this.processDataFgts(serverData[key].table.filter(row => row[11] === 'TB_FGTS'))];
      } else {
        result.servers.push(this.processDataServer(serverData[key]));
      }
    }
    return result;
  }

  static parseValue(v) {
    if (!v || v === '_' || v === '-') return null;
    return parseFloat(v.replace('.', '').replace(',', '.'));
  };

  static processDataInssIr(data) {

    const payments = data
      .map(row => {
        const id = row[2];
        const [code, description] = row[4].split(/ - (.*)/s);
        const postingId = row[8];
        const type = row[11];
        const rawValue = row[12];
        return {id, code, description, postingId, type, rawValue};
      })
      .filter(({description}) => !description.toUpperCase().includes('DOMÉSTICO'))
      .map(({id, code, description, postingId, type, rawValue}) => ({
        id,
        code,
        description,
        postingId,
        type,
        value: this.parseValue(rawValue),
      }));

    return [
      {
        name: 'Contribuição Previdenciária',
        payments: payments.filter(p => p.type === 'TB_INSS'),
      },
      {
        name: 'Imposto de Renda',
        payments: payments.filter(p => p.type === 'TB_IRPF'),
      }
    ];
  }

  static processDataFgts(data) {

    const payments = data
      .map(row => {
        const id = row[2];
        const codeLot = row[4];
        const code = row[5];
        const description = FGTSCodes['Code' + row[5]] || 'Desconhecido';
        const incidence = row[6];
        const postingId = row[8];
        const baseCalcValue = row[9];
        const type = row[11];
        const rawValue = row[12];
        return {id, codeLot, code, description, incidence, postingId, baseCalcValue, type, rawValue,};
      })
      .filter(({codeLot}) => codeLot !== '24')
      .map(({id, codeLot, code, description, incidence, postingId, baseCalcValue, type, rawValue}) => ({
        id,
        codeLot,
        code,
        description,
        incidence,
        postingId,
        baseCalcValue: this.parseValue(baseCalcValue.replace('.', ',')),
        type,
        value: this.parseValue(rawValue.replace('.', ',')),
      }));

    return [{
      name: 'FGTS',
      payments: payments.filter(p => p.type === 'TB_FGTS'),
    }]
  }

  static processDataServer(employee) {

    const isHeader = row =>
      row.includes("Código") && row.includes("Descrição") && row.includes("Tipo");

    const rows = employee.table.filter(row => !isHeader(row));

    const payments = rows
      .map(row => {
        const id = row[2];
        const code = row[4];
        const description = row[5];
        const postingId = row[8];
        const amountRaw = row[9];
        const type = row[11];
        const rawValue = row[12];
        return {
          id,
          code,
          postingId,
          type,
          description,
          amount: this.parseValue(amountRaw),
          value: this.parseValue(rawValue),
        };
      });

    return {
      name: employee.employName,
      cpf: employee.employCpf,
      cpfFormatted: employee.employCpf.padStart(11, '0').replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4"),
      payments,
    };
  }

  static createPostingFormGroup() {
    return new FormGroup({
      bankAccount: new FormControl(null),
      planAccount: new FormControl(null),
      releaseType: new FormControl(null),
      historic: new FormControl(null),
      date: new FormControl(null),
      nextMonth: new FormControl(true),
    });
  }

}

export enum FGTSCodes {
  Code11 = 'FGTS mensal',
  Code12 = 'FGTS 13º salário',
  Code13 = 'FGTS (período anterior) mensal',
  Code14 = 'FGTS (período anterior) 13º salário',
  Code15 = 'FGTS mensal - Aprendiz/Contrato Verde e Amarelo',
  Code16 = 'FGTS 13º salário - Aprendiz/Contrato Verde e Amarelo',
  Code17 = 'FGTS (período anterior) mensal - Aprendiz/Contrato Verde e Amarelo',
  Code18 = 'FGTS (período anterior) 13º salário - Aprendiz/Contrato Verde e Amarelo',
  Code21 = 'FGTS mês da rescisão',
  Code24 = 'FGTS (período anterior) mês da rescisão',
  Code27 = 'FGTS mês da rescisão - Aprendiz/Contrato Verde e Amarelo',
  Code30 = 'FGTS (período anterior) mês da rescisão - Aprendiz/Contrato Verde e Amarelo',
  Code22 = 'FGTS 13º salário rescisório',
  Code23 = 'FGTS aviso prévio indenizado',
  Code25 = 'FGTS (período anterior) 13º salário rescisório',
  Code26 = 'FGTS (período anterior) aviso prévio indenizado',
  Code28 = 'FGTS 13º salário rescisório - Aprendiz/Contrato Verde e Amarelo',
  Code29 = 'FGTS aviso prévio indenizado - Aprendiz/Contrato Verde e Amarelo',
  Code31 = 'FGTS (período anterior) 13º salário rescisório - Aprendiz/Contrato Verde e Amarelo',
  Code32 = 'FGTS (período anterior) aviso prévio indenizado - Aprendiz/Contrato Verde e Amarelo',
  Code99 = 'Indenização Compensatória (Multa do FGTS)',
  Code999 = 'Indenização Compensatória Complementar (Multa do FGTS)'
}
